const initialState = {
  loading: false,
  companies: [],
  companiesTimestamp: 0,
}

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case 'GET_COMPANIES': {
      return {
        ...state,
        loading: true,
        companiesTimestamp: 0,
      }
    }
    case 'GET_COMPANIES_COMMIT': {
      return {
        ...state,
        loading: false,
        companies: action.payload,
        companiesTimestamp: new Date().getTime(),
      }
    }
    case 'GET_COMPANIES_ROLLBACK': {
      return {
        ...state,
        loading: false,
        companiesTimestamp: 0,
      }
    }

    default: {
      return state
    }
  }
}
